module.exports = __webpack_public_path__ + "img/logo.3f733db6.png";